export async function save(
  file_content_string: string,
  filename: string,
): Promise<void> {
  const blob = new Blob([file_content_string], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.append(link);
  link.click();
  link.remove();
}
